/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { getUrls } from '@zapier/product-dev-platform';
import { jsx } from '@emotion/core';

import LinkButton from 'app/common/components/LinkButton';

import CTA from './CTA';

const CTAStart = () => (
  <CTA>
    <CTA.Main hasAside={true}>
      <CTA.Header>Join an integration as collaborators</CTA.Header>
      <CTA.Body>
        <Text color="gray60" tag="p" type="smallPrint1">
          Collaborators can log in to view performance data, user feedback, and
          access embed tools, but can’t make changes.
        </Text>
      </CTA.Body>
    </CTA.Main>
    <CTA.Aside>
      <LinkButton
        color="primary"
        href={getUrls(window.location.host).joinIntegration}
        size="small"
      >
        Get access
      </LinkButton>
    </CTA.Aside>
  </CTA>
);

export default CTAStart;
